import { isActAiExtractionResponse } from '@urbanik/api-contracts';
import { ActsApiError } from './professional-acts.js';
export async function analyzeActDocument(base, file) {
    let response;
    try {
        response = await fetch(`${base.replace(/\/$/, '')}/identity/governance/acts/ai-extraction`, {
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/pdf',
                'x-urbanik-file-name': encodeURIComponent(file.name),
            },
            body: file,
        });
    }
    catch {
        throw new ActsApiError('unavailable', 'No pudimos conectar con el analizador de actas.');
    }
    const payload = (await response.json());
    if (!response.ok) {
        const message = typeof payload === 'object' &&
            payload !== null &&
            typeof payload.message === 'string'
            ? payload.message
            : 'No pudimos analizar el acta.';
        throw new ActsApiError(response.status === 401
            ? 'unauthorized'
            : response.status === 403
                ? 'forbidden'
                : response.status === 400
                    ? 'validation'
                    : 'unavailable', message);
    }
    if (!isActAiExtractionResponse(payload))
        throw new ActsApiError('invalid', 'La propuesta de extracción no es válida.');
    return payload;
}
